module.exports = __webpack_public_path__ + "img/主要功能-res@2x.bc22a8e7.png";